import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orders: [],
  loading: false,
  error: null,
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    addOrder: (state, action) => {
      state.orders.push(action.payload);
    },
    updateOrder: (state, action) => {
      const { id, updates } = action.payload;
      const orderIndex = state.orders.findIndex(order => order.id === id);
      if (orderIndex !== -1) {
        state.orders[orderIndex] = { ...state.orders[orderIndex], ...updates };
      }
    },
    removeOrder: (state, action) => {
      state.orders = state.orders.filter(order => order.id !== action.payload);
    },
    setOrders: (state, action) => {
      state.orders = action.payload;
    },
    clearOrders: (state) => {
      state.orders = [];
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateOrderStatus: (state, action) => {
      const { id, status } = action.payload;
      const orderIndex = state.orders.findIndex(order => order.id === id);
      if (orderIndex !== -1) {
        state.orders[orderIndex].status = status;
      }
    },
  },
});

export const {
  addOrder,
  updateOrder,
  removeOrder,
  setOrders,
  updateOrderStatus,
  clearOrders,
  setLoading,
  setError,
} = ordersSlice.actions;

// Selectors
export const selectAllOrders = (state) => state.orders.orders;
export const selectOrderById = (state, id) => 
  state.orders.orders.find(order => order.id === id);
export const selectOrdersLoading = (state) => state.orders.loading;
export const selectOrdersError = (state) => state.orders.error;
export const selectOrdersCount = (state) => state.orders.orders.length;

// Filtered selectors
export const selectOrdersByType = (state, type) => 
  state.orders.orders.filter(order => order.type === type);

export const selectOrdersByEntity = (state, entityId) => 
  state.orders.orders.filter(order => order.entityId === entityId);

export const selectOrdersByStatus = (state, status) => 
  state.orders.orders.filter(order => order.status === status);

// Summary selectors
export const selectBuyOrders = (state) => 
  state.orders.orders.filter(order => order.type === 'buy');

export const selectSellOrders = (state) => 
  state.orders.orders.filter(order => order.type === 'sell');

export const selectTotalOrderValue = (state) => {
  return state.orders.orders.reduce((total, order) => {
    return total + (order.quantity * order.price);
  }, 0);
};

export const selectOrdersSummary = (state) => {
  const orders = state.orders.orders;
  const buyOrders = orders.filter(order => order.type === 'buy');
  const sellOrders = orders.filter(order => order.type === 'sell');
  
  return {
    totalOrders: orders.length,
    buyOrders: buyOrders.length,
    sellOrders: sellOrders.length,
    totalValue: orders.reduce((total, order) => total + (order.quantity * order.price), 0),
    buyValue: buyOrders.reduce((total, order) => total + (order.quantity * order.price), 0),
    sellValue: sellOrders.reduce((total, order) => total + (order.quantity * order.price), 0),
  };
};

export default ordersSlice.reducer; 